import type { TrackDataUnion, TrackEvent } from "common-types";

/**
 * Generic interface for tracking events.
 * It is used to store Tracker implementations in the Tracking class.
 * The implementations should rather extend abstract class EligibleEventsTracker.
 */
export interface Tracker {
  trackEvent({ event, payload }: TrackDataUnion): void;
}

/**
 * Abstract class used for tracking only eligible events.
 *
 * ```ts
 * class MyTracker extends EligibleEventsTracker {
 *   protected readonly eligibleTrackEvents: TrackEvent[] = [TestEvent.TEST];
 *
 *   trackEvent({ event, payload }: FandomTrackData): void {
 *     if (!this.isEligible(event)) {
 *      return;
 *     }
 *     // Tracking logic here
 *   }
 */
export abstract class EligibleEventsTracker implements Tracker {
  protected readonly eligibleTrackEvents: TrackEvent[] = [];

  isEligible(event: TrackEvent): boolean {
    return this.eligibleTrackEvents.includes(event);
  }

  abstract trackEvent({ event, payload }: TrackDataUnion): void;
}
